@let teamSpirit = pulseFeature.selectors.teamSpirit.asSignal();

<atn-summit-pulse-section name="Team Spirit">
  <div class="atn-summit-pulse-team-spirit">
    <div>
      <span class="atn-summit-pulse-team-spirit__overall-mood">
        {{ teamSpirit?.overallMood }}
      </span>
    </div>
    <div class="atn-summit-pulse-team-spirit__description">
      {{ teamSpirit?.description }}
    </div>
  </div>
</atn-summit-pulse-section>
